import { Hook } from 'lib/vendor/terrific/Sandbox';
import { Module } from 'lib/vendor/terrific/Module';
import { getProfile } from 'lib/personalization/profile';

export default class SearchInput extends Module {
	// tslint:disable-next-line: prefer-function-over-method
	public on(callback : Hook) {
		callback();
	}

	public async after() {
		const user = (await getProfile()).getUser();
		const $searchInput = this.$ctx.find('scs-search-input');
		if(user && user.getSegment()) {
			$searchInput.attr('customer-segment', user.getSegment());
		}
		$searchInput.attr('is-user-logged-in', `${!!user}`);
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/search/TC.Module.SearchInput.ts